import { Component, Input, ChangeDetectionStrategy} from '@angular/core';

export interface Measure {
	label: string;
	value: string;
}

@Component({
	selector: 'app-card-cell-footer',
	templateUrl: './card-cell-footer.component.html',
	styleUrls: ['./card-cell-footer.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardCellFooterComponent {
	@Input()
	measures!: Measure[];
}
